import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ReportItem } from 'src/app/interfaces/reports.interface';
import { ReportsService } from 'src/app/services/reports.service';

@Component({
  selector: 'app-update-report-name-modal',
  templateUrl: './update-report-name-modal.component.html',
  styleUrls: ['./update-report-name-modal.component.scss']
})
export class UpdateReportNameModalComponent implements OnInit {
  @Input() report!: ReportItem;
  @ViewChild('reportNameTextField') reportNameTextField!: ElementRef;
  reportName: string = '';
  updating: boolean = false;

  constructor(
    public modal: NgbActiveModal,
    private reportsService: ReportsService,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
    this.reportName = this.report.reportName;
    this.reportNameTextField.nativeElement.focus();
  }

  updateReportName() {
    if (!this.reportName) return;

    this.updating = true;
    this.reportsService.updateReportName(this.report.reportId, this.reportName)
      .finally(() => {
        this.updating = false;
      })
      .then((updated) => {
        if (updated) {
          this.modal.close();
          this.report.reportName = this.reportName;
        }
      })
      .catch(() => {
        this.toastr.error('Something went wrong while updating report name.');
      });
  }

}
